import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../api";
import { useLang } from "../i18n";
import { EquityChart } from "../components/TradesTable";
import { SignalsOpsTable } from "../components/SignalsOpsTable";
import { ArrowLeft } from "lucide-react";

const POS_COLOR = { LONG: "text-emerald-400", SHORT: "text-red-400", FLAT: "text-white" };

export default function YearDetail() {
  const { year } = useParams();
  const { lang, t } = useLang();
  const [yearStats, setYearStats] = useState(null);
  const [equity, setEquity] = useState([]);
  const [signals, setSignals] = useState([]);

  useEffect(() => {
    api.get("/public/performance/yearly").then((r) => setYearStats(r.data.find((y) => y.year === year) || null)).catch(() => {});
    api.get("/public/equity", { params: { year } }).then((r) => setEquity(r.data)).catch(() => {});
    api.get("/signals", { params: { year, ops: 1 } }).then((r) => setSignals(r.data.signals)).catch(() => {});
  }, [year]);

  const fmt = (v) => `${v >= 0 ? "+" : ""}${Math.round(v).toLocaleString(lang === "it" ? "it-IT" : "en-GB")} €`;

  return (
    <div data-testid="year-detail-page" className="max-w-5xl mx-auto px-4 sm:px-6 py-12">
      <Link to="/reports" data-testid="year-back-link" className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors mb-6">
        <ArrowLeft className="w-4 h-4" /> {t("nav_reports")}
      </Link>
      <div className="flex flex-wrap items-baseline gap-4">
        <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tighter text-white">{year}</h1>
        {yearStats && (
          <>
            <span data-testid="year-pl" className={`font-mono text-2xl ${yearStats.pl_eur >= 0 ? "text-emerald-400" : "text-red-400"}`}>
              {fmt(yearStats.pl_eur)} ({yearStats.pl_pct >= 0 ? "+" : ""}{yearStats.pl_pct}%)
            </span>
            <span className="font-mono text-sm text-slate-400">{yearStats.n_trades} ops · {t("win_rate")} {yearStats.win_rate}%</span>
          </>
        )}
      </div>
      <div className="mt-8"><EquityChart data={equity} /></div>
      <div data-testid="year-signals" className="mt-10">
        <h2 className="text-base md:text-lg font-medium text-white mb-4">{t("signals_history")} — {year}</h2>
        <SignalsOpsTable signals={signals} />
      </div>
    </div>
  );
}
